export interface EnvironmentConfig {
    readonly liveChatLicenseNumber: string | number;
}

export const envConfig: EnvironmentConfig = {
    get liveChatLicenseNumber() { return window.env.liveChatLicenseNumber },
};
